export const tableHeaders = [
  { label: 'ID', value: 'masterGameSubCategoryId' },
  { label: 'Name', value: 'name' },
  { label: 'Game Category', value: 'categoryname' },
  { label: 'Image Url', value: 'imageUrl' },
  { label: 'Status', value: 'status' }
]
